export default __webpack_public_path__ + "static/img-triple-crown-point-second-bd565d2d6fe3896932836450b6d9b4a8.png";